import { CALC_COLUMN_ID, overrideDisplayOf } from '../utils/buyerBoardColumns';
import type { OverrideDisplay } from '../utils/overrideDisplay';
import type { BuyerBoardColumnConfig } from './useBuyerBoardColumnConfig';

export interface OverrideDisplayPref {
  overrideDisplay: OverrideDisplay;
  setOverrideDisplay: (display: OverrideDisplay) => void;
}

/**
 * The override display, saved with the column view (the org default or the
 * buyer's own): the Simple display is the Calc column hidden.
 */
export function useOverrideDisplay(
  config: Pick<BuyerBoardColumnConfig, 'columns' | 'updateColumn'>,
): OverrideDisplayPref {
  return {
    overrideDisplay: overrideDisplayOf(config.columns),
    setOverrideDisplay: (display) =>
      config.updateColumn(CALC_COLUMN_ID, { hidden: display === 'simple' }),
  };
}
